import { pageUrl } from '@/constants/url'
import { useAccess } from '@/hooks/commons/useAccess'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useLeaveEnabledGuard = () => {
  const { leaveEnabled } = useAccess()
  const navigate = useNavigate()
  useEffect(() => {
    if (leaveEnabled === false) navigate(pageUrl.error403)
  }, [leaveEnabled, navigate])
  return { leaveEnabled }
}
